/* eslint-disable */
export const customers = [
    {
        id: "0001",
        UID: "",   // firebase user id
        firstName: "Dhananjaya",
        lastName: "CK",
        displayName: "Dhananjaya CK",
        email: "djoyrocks@gmail.com",
        company: "Prestine Technologies Pvt.Ltd",
        phoneNo: "+91-9999999999",
        avatarUrl: "assets/images/avatars/male-07.jpg"
      },
      {
        id: "0002",
        UID: "",   // firebase user id
        firstName: "Aravind",
        lastName: "Makam",
        displayName: "Aravind Makam",
        email: "makamaravind6@gmail.com",
        company: "Prestine Technologies Pvt.Ltd",
        phoneNo: "+91-9999999999",
        avatarUrl: "assets/images/avatars/male-07.jpg"
      },
      {
        id: "0003",
        UID: "",   // firebase user id
        firstName: "Chethana",
        lastName: "AP",
        email: "chethana.ap@gmail.com",
        displayName: "Chethana AP",
        company: "Prestine Technologies Pvt.Ltd",
        phoneNo: "+91-9999999999",
        avatarUrl: "assets/images/avatars/male-07.jpg"
      },
      {
        id: "0004",
        UID: "",   // firebase user id
        firstName: "Surya",
        lastName: "Prakash",
        email: "surya@awvent.com",
        displayName: "Surya Prakash",
        company: "Prestine Technologies Pvt.Ltd",
        phoneNo: "+91-9999999999",
        avatarUrl: "assets/images/avatars/male-09.jpg"
      },
      {
        id: "0005",
        UID: "",   // firebase user id
        firstName: "Mujeeb",
        lastName: "Khan",
        email: "mujeebkhank786@gmail.com",
        displayName: "Mujeeb Khan",
        company: "Prestine Technologies Pvt.Ltd",
        phoneNo: "+91-9999999999",
        avatarUrl: "assets/images/avatars/male-04.jpg"
      }
];